import type { PropTypes } from './TaskButton.types';

import { Button } from '@rango-dev/whale';
import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import styles from './TaskButton.module.css';

export function TaskButton(props: PropTypes) {
  const { t } = useTranslation();
  const { detailsData } = props;
  const navigate = useNavigate();

  const handleNavigation = useCallback(() => {
    if (!detailsData) {
      return;
    }
    navigate(
      `/bridge?fromBlockchain=${detailsData.defaultPath.from.blockchain}&fromToken=${detailsData.defaultPath.from.symbol}&toBlockchain=${detailsData.defaultPath.to.blockchain}&toToken=${detailsData?.defaultPath.to.symbol}`,
    );
  }, [navigate, detailsData]);
  const start = new Date(detailsData?.start || '');
  const end = new Date(detailsData?.end || '');
  const now = new Date().getTime();
  const beforeStart = now < start.getTime();
  const running = now >= start.getTime() && now < end.getTime();
  const ended = now > end.getTime();

  return (
    <Button
      id="campaign-task-button"
      variant="solid"
      color="cyan"
      size="2"
      radius="full"
      disabled={!running}
      onClick={handleNavigation}
      className={styles.button}>
      {beforeStart && t('Starting Soon')}
      {running && t('Join now')}
      {ended && t('Ended')}
    </Button>
  );
}
